const pagesBusinessPartnerEn = {
  add: {
    intro: {
      header: {
        headerTitle: "Add Business Partner",
      },
      body: {
        itemCard: {
          requiredDetails: "Required details:",
        },
        selectBusinessPartnerType: "Select Business Partner Type:",
        fillOutDetails: "Fill out the details",
      },
    },
    form: {
      navigation: {
        title: "Business Partner Registration",
        common: {
          submitButtonLabel: "Add Business Partner",
        },
        steps: {
          basicIdInformation: {
            title: "Business Partner ID Information",
          },
          addressAndOffice: {
            title: "Address & Office",
          },
          contactsAndPersonInCharge: {
            title: "Contacts & Person in Charge",
          },
          corporateIdInformation: {
            title: "Corporate ID Information",
          },
          individualIdInformation: {
            title: "Individual ID Information",
          },
        },
        completed: {
          result: "Result",
          message: "Business Partner added.",
          goToBusinessPartner: "Go to Details",
          completedBy: "Completed by:",
          continueAdding: "Continue adding another Business Partner",
        },
      },
      progressbar: {
        total: "Total",
        mustItem: "Required Items",
        filled: "filled",
        modeSetting: "Mode Settings",
        mustItemOnly: "Required items only",
      },
      fields: {
        basicIdInformation: {
          businessPartnerName: {
            label: "Business Partner Name",
            placeholder: "Enter business partner name",
          },
          businessPartnerShortName: {
            label: "Display Name / Short Name",
            placeholder: "Enter display name / short name",
          },
          businessPartnerCode: {
            label: "BP Code",
            placeholder: "Enter BP code",
          },
          businessPartnerStatus: {
            label: "BP Status",
            placeholder: "Select BP status",
          },
          businessPartnerRoles: {
            label: "BP Roles",
            placeholder: "Select at least one BP role",
            error: "Please select at least one BP role",
          },
          businessPartnerRegistrationDate: {
            label: "BP Registration Date",
            placeholder: "Select BP registration date",
          },
          businessPartnerTerminationDate: {
            label: "BP Termination Date",
            placeholder: "Select BP termination date",
          },
          businessPartnerActiveStartDate: {
            label: "BP Active Start Date",
            placeholder: "Select BP active start date",
          },
          businessPartnerActiveEndDate: {
            label: "BP Active End Date",
            placeholder: "Select BP active end date",
          },
          businessPartnerActivePeriod: {
            label: "BP Active Period",
            specifyEndDate: "Specify an End Date",
            placeholder: "Select BP active period",
          },
        },
        addressAndOffice: {
          individual: {
            label: "Individual Address",
            placeholder: "Current address of the linked person",
          },
        },
        contactsAndPersonInCharge: {
          individual: {
            label: "Individual Contact",
            placeholder: "Current contact of the linked person",
          },
          mainPhone: {
            label: "Main Phone",
            placeholder: "Enter main phone",
          },
          supportPhone: {
            label: "Support Phone",
            placeholder: "Enter support phone",
          },
          genericEmail: {
            label: "Generic Email",
            placeholder: "Enter generic email",
          },
          billingEmail: {
            label: "Billing Email",
            placeholder: "Enter billing email",
          },
          securityEmail: {
            label: "Security Email",
            placeholder: "Enter security email",
          },
          faxNumber: {
            label: "Fax Number",
            placeholder: "Enter fax number",
          },
          websiteUrl: {
            label: "Website URL",
            placeholder: "Enter website URL",
            add: "Add website URL",
          },
          socialMediaLink: {
            label: "Social Media Links",
            placeholder: "Enter social media links",
            add: "Add social media links",
          },
          contacts: {
            label: "Contacts",
            placeholder: "Enter contacts",
            add: "Add contact",
            columns: {
              name: {
                label: "Name",
                placeholder: "Enter name",
              },
              position: {
                label: "Position",
                placeholder: "Enter position",
              },
              email: {
                label: "Email",
                placeholder: "Enter email",
              },
              phone: {
                label: "Phone",
                placeholder: "Enter phone",
              },
              preference: {
                label: "Preference",
                placeholder: "Enter preference",
              },
            },
          },
        },
        corporateIdInformation: {
          corporateId: {
            label: "Corporate ID",
            placeholder: "Enter corporate ID",
          },
          name: {
            label: "Corporate Name",
            placeholder: "Enter corporate name",
          },
          legalName: {
            label: "Corporate Legal Name",
            placeholder: "Enter legal name",
          },
          abbreviationTradeName: {
            label: "Corporate Abbreviation/Trade Name",
            placeholder: "Enter corporate abbreviation or trade name",
          },
          nameKana: {
            label: "Corporate Name (Kana)",
            placeholder: "Enter corporate name in Kana",
          },
          nameEnglish: {
            label: "Corporate Name (English)",
            placeholder: "Enter name in English",
          },
          nameForForms: {
            label: "Corporate Name (for Forms)",
            placeholder: "Enter name for forms",
          },
          entityType: {
            label: "Entity Type",
            placeholder: "Enter entity type (e.g., Corporation, LLC)",
          },
          countryOfIncorporation: {
            label: "Country of Incorporation",
            placeholder: "Enter country (e.g., JP, US)",
          },
          registrationNumber: {
            label: "Registration Number",
            placeholder: "Enter registration number",
          },
          taxId: {
            label: "Tax ID",
            placeholder: "Enter tax ID",
          },
          lei: {
            label: "LEI",
            placeholder: "Enter LEI",
          },
          duns: {
            label: "DUNS",
            placeholder: "Enter DUNS",
          },
          establishedDate: {
            label: "Established Date",
            placeholder: "Select established date",
          },
          status: {
            label: "Corporate Status",
            placeholder: "Select corporate status",
          },
          tagline: {
            label: "Tagline",
            placeholder: "Enter tagline",
          },
          primaryLanguage: {
            label: "Primary Language",
            placeholder: "Select primary language",
          },
          transactionCurrency: {
            label: "Preferred Currency",
            placeholder: "Select currency",
          },
          timeZone: {
            label: "Time Zone",
            placeholder: "Select time zone",
          },
        },
        individualIdInformation: {
          personId: {
            label: "Linked Person",
            placeholder: "Select linked person",
          },
        },
      },
    },
  },
  list: {
    pageTitle: "Business Partners",
    addBusinessPartner: "Add Business Partner",
    filterPlaceholder: "Search by BP Name...",
    tabs: {
      corporation: "Corporation",
      individual: "Individual",
      group: "Group",
      all: "All",
    },
    businessPartnerName: "Business Partner Name",
    businessPartnerType: "BP Type",
    businessPartnerRole: "BP Role",
    businessPartnerStatus: "BP Status",
    businessPartnerActivePeriod: "BP Active Period",
    businessPartnerAddress: "Address",
    businessPartnerRegistrationDate: "BP Registration Date",
    businessPartnerTerminationDate: "BP Termination Date",
    actions: {
      export: "Export",
      share: "Share",
    },
    filters: {
      businessPartnerType: "Business Partner Type",
      businessPartnerTypePlaceholder: "Search by business partner type",
    },
  },
  detail: {
    header: {
      status: "BP Status",
      type: "BP Type",
      activePeriod: "BP Active Period",
      dataLoadFailed: "Failed to load business partner header data",
    },
    tabs: {
      detail: "Detail",
      addressAndContact: "Address & Contact",
    },
    body: {
      groups: {
        detail: "Detail",
        addressAndContact: "Address & Contact",
      },
      noDataMessage: "No data available in this section.",
      errors: {
        dataLoadFailed: "Failed to load data",
        unknownError: "An unknown error occurred",
        businessPartnerNotFound: "Business partner details not found",
        businessPartnerIdLabel: "Business Partner ID: {{id}}",
      },
    },
  },
  type: {
    corporation: "Corporation",
    individual: "Individual",
    group: "Group",
  },
  addContact: "Add Contact",
};

export default pagesBusinessPartnerEn;
